<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>      
      <v-flex xs12 sm8 md4>        
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Iniciar Sesión</v-toolbar-title>
            <v-spacer></v-spacer>
            <!--v-tooltip bottom>
              <v-btn icon large target="_blank" slot="activator">
                <v-icon large>lock</v-icon>
              </v-btn>
              <span>Registro de nuevo usuario</span>
            </v-tooltip-->
          </v-toolbar>
          <v-flex xs10 offset-xs1>
          <v-select
            v-model="empresa"
            :items="['EICOH','WATERGY']"
            label="Empresa"
            >
            <template v-slot:no-data>
                Seleccione Empresa
            </template>
          </v-select>
          </v-flex>
          <v-card-text>
            <div class="errorAlert" v-if="error">
              {{errorMsg}}
            </div>
            <v-form ref="form" @keyup.native.enter="login(usuario,contraseña)">
              <v-text-field
                v-model="usuario"
                prepend-icon="person"
                name="login"
                label="Usuario"
                type="text"
                @keydown="error=false"
                @click="error=false"
              ></v-text-field>
              <v-text-field
                v-model="contraseña"
                prepend-icon="lock"
                name="password"
                label="Contraseña"
                id="password"
                type="password"
                @keydown="error=false"
                @click="error=false"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="login(usuario,contraseña)" color="primary">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'Login',  
  data: () => ({
    contraseña: "",
    empresa: "EICOH",
    //usuario: ""
  }),
  methods: {    
    validate() {
      /*this.$router.push("menu");
      if (this.$refs.form.validate()) {
        this.$router.push("menu");
      }*/
    }
  },
  watch:{
    empresa: function (val){
      if (val == 'EICOH'){
        this.$store.commit('saveActiveAPIUrl',this.ApiBaseUrlNETCore);
        this.getAppConfig();
      } else if (val == 'WATERGY'){
        this.$store.commit('saveActiveAPIUrl',this.ApiBaseUrlNETCoreWatergy)
        this.getAppConfig();
      }
    }
  },
  computed: {
    usuario: {
      get() {
        return this.$store.state.usuario.user;
      },
      set(value) {        
        this.$store.state.usuario.user = value;
      }
    },
    error: {
      get() {
        return this.$store.state.loginError;
      },
      set(value) {
        this.$store.state.loginError = value;
      }
    },    
    errorMsg: {
      get() {
        return this.$store.state.loginErrorMsg;
      },
      set(value) {
        this.$store.state.loginErrorMsg = value;
      }
    }
  },
  mounted(){
    if (this.$store.state.usuarioLogeado){
      this.$router.push('Agenda');
    }
  }
};
</script>

<style scoped>
.errorAlert{  
  position: absolute;
  right: 10px;
  color: red;
  font-weight: 700;
}
</style>